import { useNavigation, StaticScreenProps } from "@react-navigation/native";
import { useCallback, useMemo, useState } from "react";

import { useBookingCancel, useConfig } from "../services";
import { Button, Form, Input, PickerInput } from "../lib";

type Props = StaticScreenProps<{
  id: number;
}>;

export function BookingCancelScreen({ route }: Props) {
  // Params
  const { id } = route.params;

  // Data
  const [cancelBooking, isCancelling] = useBookingCancel({ id });
  const { data: config } = useConfig();

  // State
  const [status, setStatus] = useState<string | null>(null);

  // Vars
  const navigation = useNavigation();
  const cancellationOptions = useMemo(() => {
    return (config?.cancellations ?? []).map(({ name, value }) => ({
      label: name,
      value,
    }));
  }, [config]);

  // Handlers
  const handleChange = useCallback((_name: "status", value: string | null) => {
    setStatus(value);
  }, []);

  const handleSubmit = useCallback(async () => {
    if (status) {
      await cancelBooking({ status });

      navigation.goBack();
    }
  }, [status, cancelBooking, navigation]);

  // Render
  return (
    <Form>
      <Input label="Cancellation reason">
        <PickerInput
          name="status"
          value={status ?? ""}
          onChange={handleChange}
          options={cancellationOptions}
          disabled={isCancelling}
          placeholder="Select reason"
        />
      </Input>

      <Button
        em
        loading={isCancelling}
        onPress={handleSubmit}
        disabled={!status}
      >
        Cancel booking
      </Button>
    </Form>
  );
}
